'use client';

import { Typography } from '@bgzt/ui';

import { AUTHORIZED_SHOPS, ShopId } from '~/constants/shop';
import mandarakeLogoImage from '~/public/assets/images/mandarake_logo_image_4x.webp';
import ragTagLogoImage from '~/public/assets/images/ragtag_logo_image_4x.webp';
import Image from 'next/image';

import styles from './ShopInfo.module.css';

type Props = {
  shopId: string;
};

export const ShopInfo = ({ shopId }: Props) => {
  const SHOP_DETAILS = {
    [AUTHORIZED_SHOPS.mandarake.id]: {
      logo: <Image src={mandarakeLogoImage} alt="만다라케 로고" width={44} height={44} unoptimized />,
      nameKor: '만다라케',
      nameEng: 'Mandarake',
    },
    [AUTHORIZED_SHOPS.ragTag.id]: {
      logo: <Image src={ragTagLogoImage} alt="래그태그 로고" width={44} height={44} unoptimized />,
      nameKor: '래그태그',
      nameEng: 'RAGTAG',
    },
  };

  const getShopDetail = (shopId: string) => {
    return SHOP_DETAILS[shopId as ShopId] || null;
  };
  const shopDetail = getShopDetail(shopId);
  return (
    <div className={styles.shopInfoContainer}>
      <div className={styles.shopInfoImage}>{shopDetail?.logo}</div>
      <div className={styles.shopInfo}>
        <Typography variant="L4" color="gray-900">
          {shopDetail?.nameKor}
        </Typography>
        <br />
        <Typography variant="L12" color="gray-300">
          {shopDetail?.nameEng}
        </Typography>
      </div>
    </div>
  );
};
